import 'styles/pages/brand.scss';
import '~scripts/main';

// Core
import { scrollAnimationProgress } from '~scripts/core/animations';
import { BREAKPOINTS } from '~scripts/core/breakpoints';

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import initRequestForm from '~scripts/blocks/request-form';

// Components
import '~scripts/components/modals';

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation();

//
// PAGE OFFSET
//
const pageBrandYOffset = window.pageYOffset;
const banner = document.querySelector('.banner');
let bannerOffsetHeight;

if (window.matchMedia(`(min-width: ${BREAKPOINTS.smMax})`).matches) {
  bannerOffsetHeight = 125;
}
if (window.matchMedia(`(min-width: ${BREAKPOINTS.mdMax})`).matches) {
  bannerOffsetHeight = 170;
}
if (window.matchMedia(`(min-width: ${BREAKPOINTS.lgMax})`).matches) {
  bannerOffsetHeight = 220;
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    if (pageBrandYOffset <= bannerOffsetHeight) {
      window.scrollTo(0, bannerOffsetHeight);
    }
    banner.classList.add('banner--animate');
  }, 500);
});

//
// GET PARENT ELEMENT
//
function nthParent(element, n) {
  while (n-- && element) element = element.parentNode;
  return element;
}

//
// LOGOS ANIMATION
//
let stopNumbersAnimation = [];

const handleNumbersAnimation = () => {
  const numbers = document.querySelectorAll('.js-brand-logo');
  stopNumbersAnimation = Array.from(numbers, (number) => {
    return scrollAnimationProgress(number, {
      getStart(el) {
        const height = el.offsetHeight;
        const rect = el.getBoundingClientRect();
        if (nthParent(el, 3).classList.contains('brand-block--bright')) {
          return rect.top + window.scrollY - (window.innerHeight - height / 2) / 1.2;
        } else {
          return rect.top + window.scrollY - (window.innerHeight - height / 2);
        }
      },
      getEnd(el, start) {
        return start + 10;
      },
    });
  });
};

handleNumbersAnimation();

//
// DEMO REQUEST FORM
//
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});
